export default "__VITE_ASSET__DZvu9mec__"